import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import { Header } from '../components/Header';
import Seo from '../components/Seo';
import { faqs } from '../data/faqs';


const FAQ = () => {
  const [open, setOpen] = useState(0);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map(({ q, a }) => ({
      '@type': 'Question',
      name: q,
      acceptedAnswer: { '@type': 'Answer', text: a }
    }))
  };

  return (
    <motion.div
      className="w-full min-h-screen bg-gradient-to-b from-slate-900 to-slate-800 text-white overflow-hidden"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <Seo
        title="FAQ - Frequently Asked Questions | My Football Game"
        description="Answers to the most common questions about My Football Game: how matches work, transfers, coins, tactics, playing with friends and more."
        path="/faq"
        jsonLd={jsonLd}
      />
      <div className="container mx-auto px-4">
        <Header />
      </div>

      <div className="max-w-4xl mx-auto px-4 pb-16">
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="text-center mb-10"
        >
          <h1 className="text-3xl md:text-4xl font-bold mb-3">Frequently Asked Questions</h1>
          <p className="text-white/70">
            Everything you need to know about My Football Game. New here? Read the{' '}
            <Link to="/how-to-play" className="text-green-400 hover:underline">How to Play guide</Link>{' '}
            or <Link to="/register" className="text-green-400 hover:underline">create your club for free</Link>.
          </p>
        </motion.div>

        <div className="space-y-4">
          {faqs.map((item, index) => (
            <motion.div
              key={item.q}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 + index * 0.04 }}
              className="bg-white/[0.03] backdrop-blur-sm border border-white/10 rounded-lg overflow-hidden shadow-md"
            >
              <button
                onClick={() => setOpen(open === index ? null : index)}
                className="w-full px-5 py-4 text-left flex justify-between items-center hover:bg-white/[0.05] transition-colors"
              >
                <h2 className="text-lg font-semibold pr-4">{item.q}</h2>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className={`w-5 h-5 flex-shrink-0 transition-transform ${open === index ? 'transform rotate-180' : ''}`}
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              {open === index && (
                <div className="px-5 py-4 border-t border-white/10 text-white/80">
                  <p>{item.a}</p>
                </div>
              )}
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.8 }}
          className="mt-10 bg-gradient-to-r from-green-900/30 to-emerald-900/30 p-6 rounded-xl border border-green-500/20 text-center"
        >
          <h3 className="text-xl font-bold mb-3">Still have questions?</h3>
          <p className="text-white/80 mb-6">
            Join our Discord community or jump straight into the game - the best way to learn is to manage.
          </p>
          <Link
            to="/register"
            className="inline-block px-6 py-2.5 bg-[var(--accent)] rounded-lg font-medium transition-colors shadow-md"
          >
            Start Managing for Free
          </Link>
        </motion.div>
      </div>

      <Footer />
    </motion.div>
  );
};

export default FAQ;
